import { render, staticRenderFns } from "./DemoGameStory.vue?vue&type=template&id=a9d521ec&scoped=true&"
import script from "./DemoGameStory.vue?vue&type=script&lang=js&"
export * from "./DemoGameStory.vue?vue&type=script&lang=js&"
import style0 from "./DemoGameStory.vue?vue&type=style&index=0&id=a9d521ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d521ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
